module.exports = __webpack_public_path__ + "static/img/BOYE.27e64c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/BOYE.png
// module id = KWBS
// module chunks = 0